import React, { useCallback } from 'react';
import cx from 'classnames';
import { Button } from 'reactstrap';
import { Icon } from 'js/components';

import { faUserEdit } from '@fortawesome/pro-solid-svg-icons';

import styles from './UserGroupMembers.module.scss';

export function UserGroupMember({ member, cohortClassName, onEditMember }) {
  const { user_group_member: userGroupMember } = member;

  const handleEditMember = useCallback(() => {
    onEditMember(member);
  }, [onEditMember, member]);

  return (
    <div className={styles['member-item']}>
      {/* <div style={{ fontSize: '0.6rem' }}>{JSON.stringify(member)}</div> */}
      <div className={styles['member-avatar']}>
        <div className={styles['member-avatar-image']}>
          <Icon icon="user" size="lg" />
        </div>
      </div>
      <div className={styles['member-content']}>
        <div className={styles['member-title']}>
          {userGroupMember.title ?? <span>&nbsp;</span>}
        </div>
        <div className={styles['member-name']}>{userGroupMember.name}</div>
        <div className={styles['member-email']}>
          <a href={`mailto:${userGroupMember.email}`}>
            {userGroupMember.email}
          </a>
        </div>
        <div className={styles['member-actions']}>
          <Button
            color="info"
            outline
            className="btn-inline"
            onClick={handleEditMember}
          >
            <Icon icon={faUserEdit} style={{ marginRight: '-3px' }} />
          </Button>
        </div>
      </div>
      <div className={styles['member-footer']}>
        <div className={styles['member-cohort']}>
          <label>Cohort</label>
          <div className={cx(cohortClassName, 'text-only')}>
            {member.cohort == null ? 'Unassigned' : member.cohort}
          </div>
        </div>
        <div className={styles['member-participation']}></div>
      </div>
    </div>
  );
}
export default UserGroupMember;
